import React from 'react';
import { Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { Colors } from '../../../utils/theme';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
  handleClose: () => void;
  children: React.ReactNode;
}

const InvoicePreview: React.FunctionComponent<IProps> = ({ handleClose, children }: IProps) => {
  return (
    <Dialog
      open={true}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
          display: 'flex'
        }
      }}
      PaperProps={{
        sx: {
          m: 0,
          maxWidth: '794px',
          width: '794px',
          height: '1032px',
          borderRadius: '0px'
        }
      }}
      BackdropProps={{ style: { background: Colors.modalBackground } }}
    >
      {children}
    </Dialog>
  );
};

export default InvoicePreview;
